import React from 'react';
import { FiltersDataProvider } from 'site-modules/lease-deals/components/filters/infrastructure/filters-data-provider/filters-data-provider';
import { FilterGroupContainer } from 'site-modules/lease-deals/components/filters/infrastructure/filter-group-container/filter-group-container';

const sortToggleConfig = {
  groupId: 'sortBy',
  title: 'Sort by',
  isCollapsible: false,
  items: [{ id: 'SORT_BY_HEADER', innerGroupClassName: 'visually-hidden' }],
};

export const LeaseDealsSortToggle = () => {
  return (
    <FiltersDataProvider>
      {(filtersData, onFilterUpdate) => (
        <FilterGroupContainer
          key={sortToggleConfig.groupId}
          groupConfig={sortToggleConfig}
          filtersData={filtersData}
          onFilterUpdate={onFilterUpdate}
        />
      )}
    </FiltersDataProvider>
  );
};

LeaseDealsSortToggle.displayName = 'LeaseDealsSortToggle';
